import { Action, createReducer, on } from "@ngrx/store";

import {} from "@hermes/api-model-virtual-try-on";

import * as shadeFinderActions from "../actions/shade-finder.actions";

import { SHADE_FINDER_CONFIGURATION_UNDEFINED } from "../constants/shade-finder.constant";
import {
    ShadeFinderModalStatus,
    ShadeFinderSdkError,
} from "../types/shade-finder.types";

import { initialState, ShadeFinderState } from "./shade-finder-state";

export const shadeFinderFeatureKey = "shade-finder";

const fetchShadeFinderConfigurationSuccessReducer = (
    state: ShadeFinderState,
    action: ReturnType<
        typeof shadeFinderActions.fetchShadeFinderConfigurationSuccess
    >,
): ShadeFinderState => ({
    ...state,
    shadeFinderConfig:
        action.shadeFinderConfig ?? SHADE_FINDER_CONFIGURATION_UNDEFINED,
});

const shadeFinderReducer = createReducer(
    initialState,
    on(
        shadeFinderActions.fetchShadeFinderConfigurationSuccess,
        fetchShadeFinderConfigurationSuccessReducer,
    ),
    on(
        shadeFinderActions.updateCameraDimension,
        (state, { cameraDimension }) => ({
            ...state,
            cameraDimension,
        }),
    ),
    on(shadeFinderActions.userApprove, (state) => ({
        ...state,
        isApproval: true,
    })),
    on(shadeFinderActions.userDisapprove, (state) => ({
        ...state,
        isApproval: false,
    })),
    on(shadeFinderActions.closeModal, (state) => ({
        ...state,
        modalStatus: ShadeFinderModalStatus.MODAL_CLOSED,
        sdkError: initialState.sdkError,
    })),
    on(shadeFinderActions.openModal, (state) => ({
        ...state,
        modalStatus: ShadeFinderModalStatus.MODAL_OPENED,
    })),
    on(shadeFinderActions.destroyModal, (state) => ({
        ...state,
        modalStatus: initialState.modalStatus,
        sdkError: initialState.sdkError,
        cameraDimension: initialState.cameraDimension,
    })),
    on(shadeFinderActions.launchCamera, (state) => ({
        ...state,
        modalStatus: ShadeFinderModalStatus.CAMERA_LOADING,
    })),
    on(shadeFinderActions.onAir, (state) => ({
        ...state,
        sdkError: ShadeFinderSdkError.NO_ERROR,
        modalStatus: ShadeFinderModalStatus.CAMERA_LOADED,
    })),
    on(shadeFinderActions.catchSdkError, (state, { sdkError }) => ({
        ...state,
        modalStatus: ShadeFinderModalStatus.ON_ERROR,
        sdkError,
    })),
);

export const reducer = (state: ShadeFinderState | undefined, action: Action) =>
    shadeFinderReducer(state, action);
